<template>
  <div>
    <!-- 交易号拆分 -->
    <el-dialog :title="$t('message.transactionNumberSplit')" :close-on-click-modal="false"
      :visible.sync="$parent.transactionNumberSplitDialogVisible" width="896px" center>
      <div class="content">
        <div class="header">
          <!-- 原交易号： -->
          <div class="row">
            <div class="label">
              {{ $t("message.originalTransactionNumber") }}:
            </div>
            <div class="val">{{ list[0].purchase_no }}</div>
          </div>
          <!-- 新交易号： -->
          <div class="row">
            <div class="label">{{ $t("message.newTransactionNumber") }}:</div>
            <div class="val">
              <el-input :placeholder="$t('message.newTransactionNumber')" v-model="val"
                onfocus="this.select()"></el-input>
            </div>
          </div>
        </div>
        <!-- 列表 -->
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <!--  照片-->
            <li>{{ $t("message.pic") }}</li>
            <!-- 商品属性 -->
            <li class="flex2">{{ $t("message.commodityAttribute") }}</li>
            <!-- 原交易号 -->
            <li>{{ $t("message.numberOfOriginalTransactionNumbers") }}</li>
            <!-- 拆分后剩余 -->
            <li>{{ $t("message.residualAfterSplit") }}</li>
            <!-- 新交易号数量 -->
            <li>{{ $t("message.numberOfNewTransactionNumbers") }}</li>
          </ol>
          <ul v-for="(item, index) in list" :key="index">
            <li class="flex05">{{ index + 1 }}</li>
            <!--  照片-->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                <a href="JavaScript:;" slot="reference">
                  <el-image :src="item.pic" style="width: 56px; height: 56px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </li>
            <!-- 商品属性 -->
            <li class="flex2">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 原交易号数量 -->
            <li>
              {{ item.num }}
            </li>
            <!-- 拆分后剩余 -->
            <li>{{ item.num - item.newNum }}</li>
            <!-- 新交易号数量 -->
            <li>
              <input type="number" v-model="item.newNum" class="input" @input="maxNum(index)" onfocus="this.select()" />
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="$parent.transactionNumberSplitDialogVisible = false">{{ $t("message.cancel") }}</el-button> -->
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {
      val: "",
    };
  },
  created() {
    console.log(this.list);
  },
  methods: {
    // 保存
    save() {
      let datas = {
        new_purchase_no: this.val,
        data: [],
      };
      this.list.forEach((item) => {
        datas.data.push({
          new_num: item.newNum,
          order_purchase_id: item.id,
        });
      });
      this.$api.orderApi.splitPurchaseNo(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.transactionNumberSplitDialogVisible = false;
        this.$parent.orderDetails();
      });
      // splitPurchaseNo
    },
    //最大数
    maxNum(i) {
      if (this.list[i].newNum > this.list[i].num) {
        this.list[i].newNum = this.list[i].num;
      }
      this.$forceUpdate();
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  padding: 24px;
  margin: 0px 15px;
  background-color: #f8f8f8;
  border-radius: 8px;

  .header {
    .row {
      display: flex;
      flex-wrap: wrap;
      line-height: 40px;

      .label {
        width: 80px;
        margin-right: 18px;
      }

      .val {
        width: 280px;
      }
    }
  }

  .table {
    margin-top: 16px;

    ol {
      display: flex;
      height: 40px;
      background: #edeff4;
      border-radius: 4px 4px 0px 0px;
      justify-content: center;
      align-items: center;

      li {
        height: 40px;
        text-align: center;
        align-items: center !important;
      }
    }

    ul {
      display: flex;
      padding: 10px 0;
      border-bottom: 1px solid #edeff4;
      transition: all 0.3s;

      &:hover {
        background-color: #fff;
      }

      .template {
        text-align: left;
        width: 100%;
        padding: 3%;

        .row {
          width: 100%;
          margin-bottom: 5px;
        }
      }

      .input {
        width: 80px;
        height: 38px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        text-align: center;
      }
    }

    li {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 5px;

      &:nth-last-child(1) {
        margin-right: 0;
      }
    }

    .flex05 {
      flex: 0.5;
    }

    .flex2 {
      flex: 1.5;
    }
  }
}
</style>